module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue3.274d4df9.jpg";